import { Axis, AxisRenderer } from '@amcharts/amcharts5/xy';

export type AxisRendererSettings = {
  renderer?: {};
  labels?: {};
  grids?: {};
};

export const setAxisRenderer = (axis: Axis<AxisRenderer>, settings: AxisRendererSettings) => {
  const yAxisRenderer = axis.get('renderer');

  settings.renderer && yAxisRenderer.setAll(settings.renderer);
  settings.labels && yAxisRenderer.labels.template.setAll(settings.labels);
  settings.grids && yAxisRenderer.grid.template.setAll(settings.grids);
};
